/**
 * BillStatus — 사용자PC(/u/orders) 오더 상세팝업의 세금계산서/발행 상태 처리.
 *
 * 레거시와의 관계
 * ───────────────
 * 기존 public/js/u-order-list.js 의 계산서/세금 상태 관련 전역함수를 이관했다(세금/다중발행 코어 슬라이스 C).
 *   - billNotStatusSet    : 발행상태 선택 드롭다운 열기/닫기(애니메이션)
 *   - BillTypeSetTo       : 발행방식(발행/무발행/카드/다중) 선택 → 받는자·공급자 테이블 표시 토글
 *   - check_BillStatus_new: 발행방식 라디오 변경 시 화면(아이콘·문구·다중목록) 재구성
 *   - check_BillStatus    : (구) 발행상태 선택시 금액/다중발행 목록 처리
 *   - getBillCheckN       : 현재 선택된 billstatus 라디오 → 코드(1~6). check_BillStatus 내부 전용.
 *
 * 데드코드 정리(이관하지 않고 제거): checkSooTaxIssue / checkSoogotPayed / toggle_taxWith
 *   — 전 저장소에서 호출처 0.
 *
 * 구조: 모듈 스코프 자유함수 + 얇은 브리지 클래스.
 *   - getBillCheckN 은 브리지하지 않고 모듈 스코프로만 둔다(check_BillStatus 만 호출).
 *   - 외부 전역은 bare 로 전역 해소:
 *       · multiDocumentListGet / multi_sel_list_do : 다중발행 슬라이스 B (아직 u-order-list.js 잔류 전역함수)
 *       · get_lastMisoo : 슬라이스 F(PaymentSettle) → window 브리지
 *       · number_format : 전역 유틸
 *   - last_multiselRadio 는 선언 없는 공유 암시적 전역(allSetIn_new 도 씀) → window.last_multiselRadio 로 접근.
 */
import Util from '../../../Common/Util';

function billNotStatusSet(tar,act){
    document.getElementById("billNotStatusSelone").style.display="none"; // document.getElementById("billOkStatusSelone").style.display="none";
    var obj = document.getElementById("billNotStatusSelone");
    if( act == 2 ) obj = document.getElementById("billOkStatusSelone");
    if( tar == -1 ){ return;}
    tar =document.getElementById("billStatusImgIconBTd");

    var RT = tar.getBoundingClientRect();
    //obj.style.display="block";
    obj.style.top=parseInt( RT.bottom - 5)  + "px";
    obj.style.left=parseInt(RT.left+30) + "px";
    document.getElementById("billNotStatusSelone").style.width="400px";
    // 스르륵 펼쳐지면서 나타나는 애니메이션 효과
    $("#billNotStatusSelone").animate({width: "toggle"}).promise().done(function (){
        // document.getElementById("billNotStatusSelone").style.display="block";
        $('#billNotStatusSelone').show();
    });
    //$("#billNotStatusSelone").delay(400).show("slide", { direction: "right" }, 1200);
    //$('#billNotStatusSelone').animate({"margin-right": '+=' +RT.left});
    //obj.style.left=RT.left + "px";
}

function BillTypeSetTo(val){
    var obj = document.getElementById("billstatus_" + val);
    obj.checked = true;
    if( obj){
        obj.click();
    }
    // 발행
    if( [1,4].includes(val) ){
        // 받는자, 공급자 테이블 표시
        document.getElementById("coinfoTableA").style.display="table-cell";
        document.getElementById("coinfoTableB").style.display="table-cell";
        document.getElementById("billIssuteGab").style.display="table-cell";
    }
    // 무발행
    else{
        document.getElementById("coinfoTableA").style.display="none";
        document.getElementById("coinfoTableB").style.display="none";
        document.getElementById("billIssuteGab").style.display="none";
    }
    check_BillStatus_new();
}

/**
 * 세금계산서 발행방식 선택할때 그에 맞는 화면 처리
 * @param act -1(무발행임 : 받는자, 공급자 미설정)
 */
function check_BillStatus_new(act){
    //document.getElementById("billNotStatusSelone").style.display="none";
    if( act == -1){
        document.getElementById("coinfoTableA").style.display="none";
        document.getElementById("coinfoTableB").style.display="none";
        document.getElementById("billIssuteGab").style.display="none";
    }
    $("#billNotStatusSelone").animate({width: "0"}).promise().done(function (){
        document.getElementById("billNotStatusSelone").style.display="none";
        //document.getElementById("billNotStatusSelone").style.width="0px";
    });
    var m = document.popupSetDivForm;
    var mm = parseInt(m.billstatus.value);
    // var n = 0;
    // var mgg = "값없음";
    //
    // if( document.getElementById("billstatus_0").checked==true) { n = 1; mgg = "미설정";}
    // if( document.getElementById("billstatus_1").checked==true) { n = 2; mgg = "하나만발행";}
    // if( document.getElementById("billstatus_2").checked==true) { n = 3; mgg = "카드";}
    // if( document.getElementById("billstatus_3").checked==true) { n = 4; mgg = "무발행";}
    // if( document.getElementById("billstatus_4").checked==true) { n = 5; mgg = "다중발행";}
    // if( document.getElementById("billstatus_5").checked==true) { n = 6; mgg = "다중무발행";}
    if( isNaN(mm)) mm = 0 ;

    if( mm == 0 ){
        document.getElementById("billNotStatusStr").innerHTML = "발행, 무발행";
        document.getElementById("billStatusImgIconA").src="/img/m/radio_billstatus_checked_25.png";
        document.getElementById("billStatusImgIconB").src="/img/m/radio_billstatus_unchecked_25_emp.png"
    }else{
        if( mm == 9) document.getElementById("billNotStatusStr").innerHTML = "무발행";
        if( mm == 6) document.getElementById("billNotStatusStr").innerHTML = "다중 무발행";
        if( mm == 1) document.getElementById("billNotStatusStr").innerHTML = "하나만 발행";
        if( mm == 2) document.getElementById("billNotStatusStr").innerHTML = "다중발행";
        document.getElementById("billStatusImgIconA").src="/img/m/radio_billstatus_unchecked_25_emp.png";
        document.getElementById("billStatusImgIconB").src="/img/m/radio_billstatus_checked_25.png"
    }
    document.getElementById("billNotStatusStr").style.color="#000000";
    var save_bill_info_Btn = document.getElementById("save_bill_info_Btn");
    save_bill_info_Btn.style.backgroundColor="#c0def8";
    save_bill_info_Btn.style.color="#000000";
    save_bill_info_Btn.innerHTML="저장";
    document.getElementById("bizFormHtmlDumy").innerHTML = "";
    document.getElementById("popBizHeadVal").innerHTML = "";
    document.getElementById("popBizFormlist").innerHTML = "";
    if( mm == 9 || mm == 7 ) document.getElementById("billNotStatusStr").style.color="#FFB997";
    if( mm == 1 || mm == 2 ) document.getElementById("billNotStatusStr").style.color="#0061C1";
    if( mm == 2  || mm == 6  ){
        multiDocumentListGet(null, null);
    }else{
        document.getElementById("is_relate_Div").style.display="none";
        document.getElementById("multipleOrderListTable").style.display="none";
        document.getElementById("popBizFormlist").innerHTML = "";
    }
}

function getBillCheckN(){
    var n = 0;
    if( document.getElementById("billstatus_0").checked==true) n = 1;
    if( document.getElementById("billstatus_1").checked==true) n = 2;
    if( document.getElementById("billstatus_2").checked==true) n = 3;
    if( document.getElementById("billstatus_3").checked==true) n = 4;
    if( document.getElementById("billstatus_4").checked==true) n = 5;
    if( document.getElementById("billstatus_5").checked==true) n = 6;
    return n;
}

function check_BillStatus(){ ///////////// 세금 계산서 부분 미발행, 발행, 카드 발행 무 다중발행 다중발행무 중 섡택시
    var n = getBillCheckN();

    var imgTar = document.getElementById("sooTaxIssueImg");
    var img = "/img/taxicon_tax_notset01.png";

    var multiallcancelbtn = document.getElementById("multiallcancelbtn");
    multiallcancelbtn.disabled = true;
    multiallcancelbtn.className = "acBtnDis";

    if( n != 5 && n != 6)  window.last_multiselRadio = 0;
    var obj = document.getElementById("multibillDiv");
    if( n== 2 || n == 1){
        if( n == 1 ) document.getElementById("billdate").value = "";
        var pp = parseInt(document.getElementById("thisCarorginprice").value);
        if( n == 2) pp = parseInt(pp + ( pp * 0.1));
        document.getElementById("paystate_worktotal").value= Util.formatNumber(pp);
        var obj = document.getElementById("multibillDiv");
        if(obj) obj.innerHTML = "";
        get_lastMisoo();
    }else if( n == 5 || n == 6){ /// 다중발행 다중 무
        if( window.last_multiselRadio == 5 || window.last_multiselRadio == 6  ){
            console.log("SSSSSSSSSSSSSSSS");
            var priceTotalmulti = parseInt(document.getElementById("priceTotalmulti").value);
            var priceTotalmulti_tax = parseInt( priceTotalmulti);
            if( document.getElementById("billstatus_4").checked==true) priceTotalmulti_tax = parseInt( priceTotalmulti + ( priceTotalmulti * 0.1));
            document.getElementById("paystate_worktotal").value=Util.formatNumber(priceTotalmulti_tax) ;
            return;
        }
        window.last_multiselRadio = n;
        var baseTR = document.getElementById("multibillDiv_copy").innerHTML;
        obj.innerHTML = baseTR + "<tr style='height:50px;'><td tdcd=104 colspan=10 style='height:50px;line-height:50px;text-align:center'>선택된 오더를 불러오고 있습니다.</td></tr>";
        multi_sel_list_do();

    }else{
        if( n == 4 ){
            document.getElementById("billdate").value="";
            document.getElementById("billTowho").value="";
            document.getElementById("billPrice").value=0;
            var pp = parseInt(document.getElementById("thisCarorginprice").value);
            document.getElementById("paystate_worktotal").value = Util.formatNumber(pp);
        }
        if( obj) obj.innerHTML = "";
    }
}

export default class BillStatus {
    billNotStatusSet = billNotStatusSet;
    BillTypeSetTo = BillTypeSetTo;
    check_BillStatus_new = check_BillStatus_new;
    check_BillStatus = check_BillStatus;
}
